'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');

var _require = require('emerge'),
    is = _require.is,
    equalBy = _require.equalBy;

var _require2 = require('fpx'),
    includes = _require2.includes,
    isFunction = _require2.isFunction,
    isObject = _require2.isObject;

var _require3 = require('espo'),
    Que = _require3.Que,
    Reaction = _require3.Reaction,
    bindAll = _require3.bindAll;

var _React$createElement = React.createElement('div'),
    elementMarker = _React$createElement.$$typeof;

/**
 * Classes
 */

// Purpose: batching view updates. When running multiple data updates that could
// trigger multiple render phases, we can .dam() the shared render que, update,
// then flush the que, avoiding redundant renders that could have happened
// during the update.


var RenderQue = function (_Que) {
  _inherits(RenderQue, _Que);

  function RenderQue() {
    _classCallCheck(this, RenderQue);

    var _this = _possibleConstructorReturn(this, _Que.call(this, forceUpdateInstance));

    if (_this.constructor === RenderQue) bindAll(_this);
    return _this;
  }

  RenderQue.prototype.push = function push(value) {
    if (isComponentInstance(value) && !includes(this.pending, value)) _Que.prototype.push.call(this, value);
  };

  return RenderQue;
}(Que);

RenderQue.global = new RenderQue();

exports.RenderQue = RenderQue;

// Enables implicit reactivity driven by procedural data access (adapts React
// views to espo.Reaction). Enables custom batching of view updates via
// RenderQue.global. Safely handles exceptions in lifecycle methods to ensure
// proper resource cleanup.
//
// Note on exception handling. React fails to unmount components that throw an
// exception during a lifecycle method such as `render` or `componentWillMount`.
// This screws up resource cleanup and seems to sometimes cause React to get
// stuck in an inconsistent state, breaking it. Replacing exceptions with
// console reports circumvents the problem. (Note: need to check behavior in
// React 16+.)

var PraxComponent = function (_React$Component) {
  _inherits(PraxComponent, _React$Component);

  function PraxComponent() {
    _classCallCheck(this, PraxComponent);

    var _this2 = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));

    _this2.reaction = new Reaction();
    _this2.scheduleUpdate = _this2.renderQue.push.bind(_this2.renderQue, _this2);
    if (isFunction(_this2.subrender)) _this2.subrender = _this2.subrender.bind(_this2);
    return _this2;
  }

  // Prevents unnecessary renders caused by ancestor instances. Works best if
  // props and state are kept shallow.


  PraxComponent.prototype.shouldComponentUpdate = function shouldComponentUpdate(props, state) {
    return !reactEqual(this.props, props) || !reactEqual(this.state, state);
  };

  PraxComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.renderQue.pull(this);
    this.reaction.deinit();
  };

  PraxComponent.prototype.render = function render() {
    if (!isFunction(this.subrender)) return null;
    try {
      return this.reaction.run(this.subrender, this.scheduleUpdate);
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  return PraxComponent;
}(React.Component);

exports.PraxComponent = PraxComponent;

PraxComponent.prototype.renderQue = RenderQue.global;

/**
 * Utils
 */

function forceUpdateInstance(instance) {
  instance.forceUpdate();
}

exports.isComponentInstance = isComponentInstance;
function isComponentInstance(value) {
  return isObject(value) && isFunction(value.forceUpdate);
}

exports.isElement = isElement;
function isElement(value) {
  return isObject(value) && value.$$typeof === elementMarker;
}

exports.reactEqual = reactEqual;
function reactEqual(left, right) {
  return isElement(left) && isElement(right) ? elemEqual(left, right) : equalBy(reactEqual, left, right);
}

function elemEqual(left, right) {
  return is(left.type, right.type) && is(left.key, right.key) && propsEqual(left.props, right.props);
}

function propsEqual(left, right) {
  for (var key in left) {
    if (key === 'children') continue;
    if (!reactEqual(left[key], right[key])) return false;
  }

  for (var _key in right) {
    if (_key === 'children') continue;
    if (!reactEqual(left[_key], right[_key])) return false;
  }

  return reactEqual(left.children, right.children);
}

// Utility for extra paranoid `shouldComponentUpdate`.
exports.reactPseudoEqual = reactPseudoEqual;
function reactPseudoEqual(left, right) {
  return isFunction(left) && isFunction(right) || (isElement(left, right) ? elemEqual(left, right) : equalBy(reactPseudoEqual, left, right));
}


//////////////////
// WEBPACK FOOTER
// ./~/prax/dist/react.js
// module id = 2359
// module chunks = 118